import { Collection } from '@msw/data'
import { welfareCampaignSchema } from 'app/src/msw/membership/schemas/userInfoSchema'
import type { UserFamilyMember } from 'app/src/services/welfareportal'

// FAMILY MEMBERS COLLECTION
const welfareCampaignCollection = new Collection({
  schema: welfareCampaignSchema,
  // extensions: [persist()],
})

export { welfareCampaignCollection }

export const createWelfareCampaignSeed = async (filters?: {
  onlyDiscount?: boolean
  onlyCatalog?: boolean
  onlyPlus?: boolean
}) => {
  const existingData = await welfareCampaignCollection.findMany()

  console.log('MSW: Checking existing Family Members data, found', existingData.length)

  if (existingData.length > 0) {
    return
  }

  const jsonData = await (await fetch('./data/membership/welfareCampaign.json')).json()

  // Filtra le campagne in base ai parametri
  let campaigns = jsonData
  if (filters?.onlyDiscount || filters?.onlyCatalog || filters?.onlyPlus) {
    campaigns = jsonData.filter((item: { campaignName?: string }) => {
      const name = item.campaignName?.toLowerCase() || ''

      if (filters.onlyPlus && name.includes('plus')) {
        return true
      }
      if (filters.onlyCatalog && name.includes('catalogo') && !name.includes('plus')) {
        return true
      }
      if (filters.onlyDiscount && name.includes('sconti') && !name.includes('plus')) {
        return true
      }

      return false
    })
  }

  campaigns.forEach(async (item: UserFamilyMember) => {
    console.log('createWelfareCampaignSeed - creating item', item)
    const createdWelfareCampaign = await welfareCampaignCollection.create(item)
    console.log('createWelfareCampaignSeed', createdWelfareCampaign)
  })
  console.log('MSW: Seeding Welfare Campaign data')
}

export const clearWelfareCampaignSeed = async () => {
  const existingData = await welfareCampaignCollection.findMany()
  existingData.forEach(async (item) => {
    await welfareCampaignCollection.delete(item)
  })
  console.log('MSW: Clearing Welfare Campaign data')
}
